module.exports = __webpack_public_path__ + "static/responsive-stack-chart-47f04210abeca2147520d2bae19addf4.png";